import Footer from '../Footer/Footer';
import { Fragment } from "react";
import Navigation from "../Navigation/Navigation";

const Terms = () => {
    return (
        <Fragment>
            <div className="loader">
                <div className="loader-inner">
                    <img src="assets/images/loader.gif" alt="Loader GIF" className="loader-img" loop="infinite" />
                </div>
            </div>
            <Navigation />
            {/* <!-- Hero Section Start  --> */}
            <div className="hero-section serv-page-hero serv-bg" id="">
                <div className="container h-100">
                    <div className="row d-flex align-items-center hero-inner justify-content-center h-100">
                        <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 serv-left">
                            <div className="serv-text">
                                <h2>Terms & Conditions</h2>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.                                </p>
                            </div>
                        </div>

                    </div>

                    {/* <!-- Container End--> */}
                </div>
            </div>
            {/* <!-- Hero Section End  --> */}
            <Footer />

        </Fragment>
    )
}
export default Terms;